export const getDetectionErrorName = ({
  noCam,
  noMic,
  noSpeaker,
}: {
  noCam: boolean;
  noMic: boolean;
  noSpeaker: boolean;
}) => {
  if (noCam && noMic && noSpeaker)
    return "micCamCheck:cam.mic.speaker.not.found";

  if (noCam && noMic) return "micCamCheck:cam.mic.not.found";

  if (noCam && noSpeaker) return "micCamCheck:cam.speaker.not.found";

  if (noMic && noSpeaker) return "micCamCheck:mic.speaker.not.found";

  if (noCam) return "micCamCheck:cam.not.found";

  if (noMic) return "micCamCheck:mic.not.found";

  if (noSpeaker) return "micCamCheck:speaker.not.found";

  return "";
};

export const getDetectionErrorMessage = ({
  noCam,
  noMic,
  noSpeaker,
}: {
  noCam: boolean;
  noMic: boolean;
  noSpeaker: boolean;
}) => {
  if (noCam && noMic && noSpeaker)
    return "micCamCheck:cam.mic.speaker.not.found.message";

  if (noCam && noMic) return "micCamCheck:cam.mic.not.found.message";

  if (noCam && noSpeaker) return "micCamCheck:cam.speaker.not.found.message";

  if (noMic && noSpeaker) return "micCamCheck:mic.speaker.not.found.message";

  if (noCam) return "micCamCheck:cam.not.found.message";

  if (noMic) return "micCamCheck:mic.not.found.message";

  if (noSpeaker) return "micCamCheck:speaker.not.found.message";

  return "";
};

export const getDetectionErrorStepOne = (noCam: boolean, noMic: boolean) =>
  `micCamCheck:device.not.found.step.1.${
    // eslint-disable-next-line no-nested-ternary
    noCam && noMic ? "both" : noCam ? "cam" : "mic"
  }`;

export const getDetectionError = ({
  audio,
  video,
  speaker,
}: {
  audio: boolean;
  video: boolean;
  speaker: boolean;
}): string => {
  if (audio && video) return "both";
  if (audio) return "mic";
  if (video) return "cam";
  if (speaker) return "speaker";
  return "";
};
